import { defineMessage } from 'services/localization';

export const messages = {
    billingNameAnnual: defineMessage('yearly'),
    billingNameBiAnnually: defineMessage('biyearly'),
    billingNameMonthly: defineMessage('monthly'),
    billingNameQuarterly: defineMessage('quarterly'),
    billingNameOneTime: defineMessage('one_time'),
    planNameRetired: defineMessage('retired'),
    planNameProfessional: defineMessage('approvalmax_professional'),
    planNameXeroPremium: defineMessage('approvalmax_for_xero_premium'),
    planNameQBooksPremium: defineMessage('approvalmax_for_quickbooks_online_premium'),
    planNameNetSuitePremium: defineMessage('approvalmax_for_netsuite_premium'),
    planNameXeroAdvanced: defineMessage('approvalmax_for_xero_advanced'),
    planNameQBooksAdvanced: defineMessage('approvalmax_for_quickbooks_online_advanced'),
    planNameNetSuiteAdvanced: defineMessage('approvalmax_for_netsuite_advanced'),
    planNameXero: defineMessage('approvalmax_for_xero_standard'),
    planNameQBooks: defineMessage('approvalmax_for_quickbooks_online_standard'),
    planNameNetSuite: defineMessage('approvalmax_for_netsuite_standard'),
    planNameTrial: defineMessage('approvalmax_professional_trial'),
    planNamePartner: defineMessage('approvalmax_for_partners'),
    planNamePaymentRequired: defineMessage('approvalmax_payment_required'),
    receiptBankProfessional: defineMessage('dext_prepare_professional'),
    receiptBankQuickBooksOnlineStandard: defineMessage('dext_prepare_quickbooks_online_standard'),
    receiptBankQuickBooksOnlineAdvanced: defineMessage('dext_prepare_quickbooks_online_advanced'),
    receiptBankQuickBooksOnlinePremium: defineMessage('dext_prepare_quickbooks_online_premium'),
    receiptBankXeroStandard: defineMessage('dext_prepare_xero_standard'),
    receiptBankXeroAdvanced: defineMessage('dext_prepare_xero_advanced'),
    receiptBankXeroPremium: defineMessage('dext_prepare_xero_premium'),
    cin7CorePremium: defineMessage('approvalmax_cin_core_premium'),
    bookkeepersAndAccountantPackage: defineMessage('approvalmax_for_accountants_bookkeepers'),
    smallBusinessPackage: defineMessage('approvalmax_small_business_package'),
};
